/* eslint-disable no-restricted-globals */
import {
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  IDTextbox,
  GroupNumTextbox,
  ReportingHeaderTextbox,
  StartQtrTextbox,
  EndQtrTextbox,
  DeleteBoxRender,
} from './gridComponents/cgpFrameworks';
import {
  defaultCgpDetailTableHead,
  planIdCgpDetailTableHead,
  providerCgpDetailTableHead,
  MCOCgpDetailTableHead,
  deleteColumn,
} from './gridComponents/tableHead';
import {
  addNewRowData,
  deleteCGPRow,
  getClaimGrouping,
  resetCGPDetailStore,
  saveClaimGrouping,
  setDetailErrorMessages,
  setDetailSuccessMessages,
  setShoWAllHistoryValue,
  setTableAdd,
  setTableEdit,
  setTableEditedData,
  setValidateTrigger,
  setDeleteRowIndex,
  setNewCGPDetailRowData
} from '../store/actions';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  ALL_REMAINING_VALUE,
  DUPLICATE_ALL,
  GROUP_NUM_RANGE_ERR,
  GROUP_NUM_REQUIRED_ERR,
  ID_REQUIRED_ERR,
  OVERAP_DATE,
  QUARTER_FORMAT_ERROR,
  SINGLE_GROUP_HEADER,
  START_QTR_REQUIRED_ERR,
  SUCCESS_SAVE_MSG,
} from './constantData';
import {
  closeTab,
  convertQuaterToDate,
  convertQuatreManufacturer,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { FUTURE_QUARTER_ERROR } from '../../../../SharedModules/Errors/constantMessageData';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

const ClaimGroupingParameterDetail = ({ location }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isReadOnly } = location;
  const [loading, setLoading] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [openIgnore, setOpenIgnore] = useState(false);
  const [fieldErr, setFieldErr] = useState({
    endQtrErr: false,
    overlapErr: false,
    singleCdReqErr: false,
  });
  const [isMounted, setIsMounted] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [willDeleteRowIndex, setWillDeleteRowIndex] = useState(-1);

  const CGPSearchValues = useSelector(
    (state) => state.sharedState.CGPReducer?.CGPSearchValues
  );
  const deleteRowIndex = useSelector(
    (state) => state.sharedState.CGPReducer?.deleteRowIndex
  );
  const stortedGroupingColumns = useSelector(
    (state) => state.sharedState.CGPReducer?.stortedGroupingColumns
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const detailTableData = useSelector(
    (state) =>
      state.sharedState.CGPReducer?.detailTableData?.filter(
        (item) => item.groupingColumnValue !== ALL_REMAINING_VALUE
      ) ?? []
  );
   const detailTableDataFullData = useSelector(
    (state) =>
      state.sharedState.CGPReducer?.detailTableData ?? []
  );
  const bottomStorData = useSelector(
    (state) =>
      state.sharedState.CGPReducer?.detailTableData?.filter(
        (item) => item.groupingColumnValue === ALL_REMAINING_VALUE
      ) ?? []
  );
  const tableBottomData = bottomStorData?.length
    ? bottomStorData
    : [
        {
          rpcClaimGroupingParamPK: {
            groupingColumn: CGPSearchValues?.groupingColumn,
            rebateProgramCd: CGPSearchValues?.rebateProgramCd,
          },
          groupNum: 99,
          groupingColumnValue: ALL_REMAINING_VALUE,
          startQtr: CGPSearchValues.quarter,
          newOrUpdateRecord: true,
          deleteRecord: false,
          addedUserId: UserDefaultValues?.userId ?? logInUser,
          groupHeader: null,
          addedDate: moment().format('MM/DD/YYYY'),
        },
      ];

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const errorMessages = useSelector(
    (state) => state.sharedState.CGPReducer?.detailErrorMessages
  );
  const successMessages = useSelector(
    (state) => state.sharedState.CGPReducer?.detailSuccessMessages
  );
  const showAllHistory = useSelector(
    (state) => state.sharedState.CGPReducer?.showAllHistory
  );
  const edit = useSelector((state) => state.sharedState.CGPReducer?.tableEdit);
  const editedData =
    useSelector((state) => state.sharedState.CGPReducer?.tableEditedData) ?? [];

  const [cgpDetailTableHead, setCgpDetailTableHead] = useState(
    defaultCgpDetailTableHead
  );

  const setErrorMessages = (values) => dispatch(setDetailErrorMessages(values));
  const setSuccessMessages = (values) =>
    dispatch(setDetailSuccessMessages(values));
  const setShoWAllHistory = (values) =>
    dispatch(setShoWAllHistoryValue(values));
  const setAdd = (values) => dispatch(setTableAdd(values));
  const setEdit = (values) => dispatch(setTableEdit(values));
  const setEditedData = (values) => dispatch(setTableEditedData(values));
  const [originalRowCount, setOriginalRowCount] = useState(0); 

  const isNewRecord = (rowData) => {
    return (
      rowData.newOrUpdateRecord === true &&
      !rowData.rpcClaimGroupingParamPK?.groupingColumnValue
    );
  };

  const isEditedRecord = (rowData) => {
    return (
      rowData.newOrUpdateRecord === true &&
      rowData.rpcClaimGroupingParamPK?.groupingColumnValue
    );
  };

  const onEditingStopped = useCallback(
    (e) => {
      if (e.column.colId === 'startQtr') {
        refreshEndQtrCell(e.rowIndex);
      }
      setSuccessMessages([]);
      setEdit(true);
      if (e && e.value !== e.oldValue) {
        const obj = e.data;
        const newData = !_.isEmpty(editedData)
          ? _.filter(editedData, (l) => l.index !== e.rowIndex)
          : [];
        obj.newOrUpdateRecord = true;
        newData.push(obj);
        setEditedData(newData);
      }
    },
    [editedData]
  );
     
  useEffect(() => {
    if (
      detailTableDataFullData &&
      detailTableDataFullData.length > 0 &&
      originalRowCount === 0
    ) {
      // Count only non-deleted existing rows
      const existingCount = detailTableDataFullData.filter(
        (row) => !row.deleteRecord && !row.newOrUpdateRecord
      ).length;
      setOriginalRowCount(existingCount);
    }
  }, [detailTableDataFullData]);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!showAllHistory) {
      if (CGPSearchValues.groupingColumn === 'Plan ID')
        setCgpDetailTableHead([...deleteColumn, ...planIdCgpDetailTableHead]);
      if (CGPSearchValues.groupingColumn === 'Alternate Provider ID')
        setCgpDetailTableHead([...deleteColumn, ...providerCgpDetailTableHead]);
      if (CGPSearchValues.groupingColumn === 'MCO Indicator')
        setCgpDetailTableHead([...deleteColumn, ...MCOCgpDetailTableHead]);
    } else {
      setCgpDetailTableHead([...deleteColumn, ...defaultCgpDetailTableHead]);
    }
  }, [showAllHistory]);

  const frameworkComponents = {
    IDTextbox: (cellInfo) => (
      <IDTextbox
        cellInfo={cellInfo}
        setFieldErr={setFieldErr}
        fieldErr={fieldErr}
        isReadOnly={isReadOnly}
        onBlurValidation={validateSingleRowOnBlur}
      />
    ),
    GroupNumTextbox: (cellInfo) => (
      <GroupNumTextbox
        cellInfo={cellInfo}
        setFieldErr={setFieldErr}
        fieldErr={fieldErr}
        isReadOnly={isReadOnly}
        onBlurValidation={validateSingleRowOnBlur}
      />
    ),
    ReportingHeaderTextbox: (cellInfo) => (
      <ReportingHeaderTextbox
        cellInfo={cellInfo}
        setFieldErr={setFieldErr}
        fieldErr={fieldErr}
        isReadOnly={isReadOnly}
        onBlurValidation={validateSingleRowOnBlur}
      />
    ),
    StartQtrTextbox: (cellInfo) => (
      <StartQtrTextbox
        cellInfo={cellInfo}
        setFieldErr={setFieldErr}
        fieldErr={fieldErr}
        isReadOnly={isReadOnly}
        onBlurValidation={validateSingleRowOnBlur}
      />
    ),
    EndQtrTextbox: (cellInfo) => (
      <EndQtrTextbox
        cellInfo={cellInfo}
        setFieldErr={setFieldErr}
        fieldErr={fieldErr}
        isReadOnly={isReadOnly}
        addAction={addCGPRow}
        onBlurValidation={validateSingleRowOnBlur}
      />
    ),
    deleteBoxRenderer: (props) => (
      <div>
        {props?.data?.groupingColumnValue != ALL_REMAINING_VALUE ? (
          <DeleteBoxRender
            {...props}
            isReadOnly={isReadOnly}
            onClick={(data) => {
              dispatch(setDeleteRowIndex(data.rowIndex));
              setOpenDelete(true);

            }}
          />
        ) : null}
      </div>
    ),
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const refreshEndQtrCell = (rowIndex) => {
    if (gridApi) {
      const rowNode = gridApi.getRowNode(`${rowIndex}`);
      gridApi.refreshCells({
        rowStartIndex: rowNode.rowIndex,
        rowEndIndex: rowNode.rowIndex,
        columns: ['endQtr'],
        force: true,
      });
    }
  };
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/claimGroupingParameterDetail') {
          if (edit) {
            item.isFormDirty = true;
          } else {
            item.isFormDirty = false;
          }
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages, edit]);

  // close popup on click button
  useEffect(() => {
    if (isMounted) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/claimGroupingParameterDetail' && x.isFormSave;
        }).length > 0
      ) {
        const newObj = updateTabs.map((item) => {
          if (
            item.navTo === '/claimGroupingParameterDetail' &&
            item.isFormSave
          ) {
            item.isFormSave = false;
            saveAndCloseTab();
          }
          return item;
        });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const dispatchClaimGrouping = async (showAllCheck = null) => {
    await dispatch(
      getClaimGrouping({
        rebateProgramCd: CGPSearchValues.rebateProgramCd,
        groupingColumn: CGPSearchValues.groupingColumn,
        groupingColumnValue: stortedGroupingColumns.find(
          (obj) => obj.groupingColumn === CGPSearchValues.groupingColumn
        )?.groupingColumnValue,
        qtr: CGPSearchValues.quarter,
        showAllCheckBox: showAllCheck === null ? showAllHistory : showAllCheck,
      })
    );
  };

  const handleChangeShowAllHistory = () => {
    if (!edit) {
      setShoWAllHistory(!showAllHistory);
      if (isMounted) dispatchClaimGrouping(!showAllHistory);
    } else {
      setOpenIgnore(true);
    }
  };
  const addCGPRow = (e, data) => {
    setErrorMessages([]);
    setAdd(true);
    setSuccessMessages([]);
    const blankObj = [
      {
        rpcClaimGroupingParamPK: {
          rebateProgramCd: CGPSearchValues?.rebateProgramCd,
          groupingColumn: CGPSearchValues?.groupingColumn,
        },
        groupingColumnValue: '',
        groupNum: '',
        groupHeader: '',
        startQtr: '',
        endQtr: '',
        newOrUpdateRecord: true,
      },
    ];
    dispatch(addNewRowData(blankObj[0]));
    if (data) {
      let newData = [...data];
      newData.push(blankObj[0]);
      setEditedData(newData);
    } else editedData.push(blankObj[0]);
    setEdit(true);
  };
  const openSave = () => {
    setSuccessMessages([]);
    setOpen((edit && _.isEmpty(errorMessages)) || false);
  };
  const saveAndCloseTab = () => {
    masterDataSave(true);
  };
  const masterDataSave = async (willCloseTab = false) => {
    setErrorMessages([]);
    setSuccessMessages([]);
    if (isFormValid()) {
      const successMsg = await dispatch(
        saveClaimGrouping([
          ...detailTableData.map((row) => ({
            ...row,
            rpcClaimGroupingParamPK: {
              ...row.rpcClaimGroupingParamPK,
              groupingColumnValue: row.groupingColumnValue,
              startQtr: row.startQtr,
            },
            endQtr: row.endQtr || null,
          })),
          ...tableBottomData?.map((row) => ({
            ...row,
            rpcClaimGroupingParamPK: {
              ...row.rpcClaimGroupingParamPK,
              groupingColumnValue: row.groupingColumnValue,
              startQtr: row.startQtr,
            },
            endQtr: row.endQtr || null,
          })),
        ])
      );
      await dispatchClaimGrouping();
      if (successMsg) {
        setSuccessMessages([SUCCESS_SAVE_MSG]);
      }
      setEdit(false);
      setEditedData([]);
      dispatch(setValidateTrigger(false));
      if (willCloseTab) {
        dispatch(resetCGPDetailStore());
        closeTab('/claimGroupingParameterDetail', history);
      }
    }
    setOpen(false);
  };

  const cancel = async () => {
    await dispatchClaimGrouping();
    setErrorMessages([]);
    setSuccessMessages([]);
    setEdit(false);
    setEditedData([]);
    dispatch(setValidateTrigger(false));
    setOpenCancel(false);
  };

  const handleViewHistory = () => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.rpcClaimGroupingParamPK;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        REBATE_PROGRAM_CD: `${selectedRow?.rebateProgramCd}`,
        GROUPING_COLUMN: `${selectedRow?.groupingColumn}`,
        GROUPING_COLUMN_VALUE: `${selectedRow?.groupingColumnValue}`,
        START_QTR: `${selectedRow?.startQtr}`,
      });
    }
  };
  const isFormValid = () => {
    let showStrtDtErr = false;
    let showQtrErr = false;
    const errorMessagesArray = [];
    const tableData = [...detailTableData, ...tableBottomData];
    const newAndEditedRows = tableData.filter(
      (row) => row.newOrUpdateRecord && !row.deleteRecord
    );
    const allActiveRows = tableData.filter((row) => !row.deleteRecord);
    newAndEditedRows.forEach((rowA) => {
      allActiveRows.forEach((rowB) => {
        if (
          rowA === rowB ||
          (rowA.rpcClaimGroupingParamPK?.groupingColumnValue ===
            rowB.rpcClaimGroupingParamPK?.groupingColumnValue &&
            rowA.rpcClaimGroupingParamPK?.startQtr ===
              rowB.rpcClaimGroupingParamPK?.startQtr &&
            rowA.groupNum === rowB.groupNum &&
            !rowA.newOrUpdateRecord)
        ) {
          return;
        }
        if (
          rowA?.groupingColumnValue &&
          rowB?.groupingColumnValue &&
          String(rowA.groupingColumnValue).trim() ===
            String(rowB.groupingColumnValue).trim() &&
          rowA?.groupNum &&
          rowB?.groupNum &&
          String(rowA.groupNum) === String(rowB.groupNum) &&
          rowA?.startQtr &&
          rowB?.startQtr &&
          String(rowA.startQtr)?.toLowerCase() ===
            String(rowB.startQtr)?.toLowerCase()
        ) {
          if (rowA.endQtr && rowB.endQtr) {
            if (
              String(rowA.endQtr)?.toLowerCase() ===
              String(rowB.endQtr)?.toLowerCase()
            ) {
              errorMessagesArray.push(DUPLICATE_ALL);
            }
          } else {
            errorMessagesArray.push(DUPLICATE_ALL);
          }
        } else if (
          rowA?.groupingColumnValue &&
          rowB?.groupingColumnValue &&
          String(rowA.groupingColumnValue).trim() !==
            String(rowB.groupingColumnValue).trim() &&
          rowA?.groupNum &&
          rowB?.groupNum &&
          String(rowA.groupNum) === String(rowB.groupNum) &&
          rowA?.groupHeader &&
          rowB?.groupHeader &&
          String(rowA.groupHeader).trim() !== String(rowB.groupHeader).trim()
        ) {
          if (rowA.startQtr && rowB.startQtr) {
            const aStartDate = new Date(convertQuaterToDate(rowA.startQtr));
            const aEndDate = rowA.endQtr
              ? new Date(convertQuaterToDate(rowA.endQtr))
              : new Date('9999-12-31');
            const bStartDate = new Date(convertQuaterToDate(rowB.startQtr));
            const bEndDate = rowB.endQtr
              ? new Date(convertQuaterToDate(rowB.endQtr))
              : new Date('9999-12-31');

            const hasOverlap = aStartDate <= bEndDate && aEndDate >= bStartDate;

            if (hasOverlap) {
              errorMessagesArray.push(SINGLE_GROUP_HEADER);
            }
          }
        } else if (
          rowA?.groupingColumnValue &&
          rowB?.groupingColumnValue &&
          String(rowA.groupingColumnValue).trim() ===
            String(rowB.groupingColumnValue).trim() &&
          rowA?.groupNum &&
          rowB?.groupNum &&
          String(rowA.groupNum) === String(rowB.groupNum) &&
          rowA?.startQtr &&
          rowB?.startQtr
        ) {
          const aStartDate = new Date(convertQuaterToDate(rowA.startQtr));
          const aEndDate = rowA.endQtr
            ? new Date(convertQuaterToDate(rowA.endQtr))
            : new Date('9999-12-31');
          const bStartDate = new Date(convertQuaterToDate(rowB.startQtr));
          const bEndDate = rowB.endQtr
            ? new Date(convertQuaterToDate(rowB.endQtr))
            : new Date('9999-12-31');

          const hasOverlap = aStartDate <= bEndDate && aEndDate >= bStartDate;
          const isExactMatch =
            String(rowA.startQtr)?.toLowerCase() ===
              String(rowB.startQtr)?.toLowerCase() &&
            ((rowA.endQtr &&
              rowB.endQtr &&
              String(rowA.endQtr)?.toLowerCase() ===
                String(rowB.endQtr)?.toLowerCase()) ||
              (!rowA.endQtr && !rowB.endQtr));

          if (hasOverlap && !isExactMatch) {
            errorMessagesArray.push(OVERAP_DATE);
          }
        }
      });
    });

    // individual validation
    editedData.forEach((item) => {
      if (!item.newOrUpdateRecord || item.deleteRecord) {
        return;
      }

      let endQtrDate = '';
      let startQtrDate = '';

      if (!item.groupingColumnValue) {
        if (showAllHistory) {
          errorMessagesArray.push(`Grouping Column Value${ID_REQUIRED_ERR}`);
        } else {
          errorMessagesArray.push(
            item.rpcClaimGroupingParamPK.groupingColumn + ID_REQUIRED_ERR
          );
        }
      }

      if (!item.groupNum) {
        errorMessagesArray.push(GROUP_NUM_REQUIRED_ERR);
      } else if (
        item.groupingColumnValue !== ALL_REMAINING_VALUE &&
        Number(item.groupNum) !== 99 &&
        (isNaN(Number(item.groupNum)) ||
          Number(item.groupNum) < 1 ||
          Number(item.groupNum) > 10)
      ) {
        errorMessagesArray.push(GROUP_NUM_RANGE_ERR);
      }

      if (item.startQtr === '') {
        showStrtDtErr = true;
        errorMessagesArray.push(START_QTR_REQUIRED_ERR);
      } else if (
        item.startQtr !== '' &&
        item.startQtr !== null &&
        !convertQuatreManufacturer(item.startQtr)
      ) {
        showQtrErr = true;
        errorMessagesArray.push(QUARTER_FORMAT_ERROR);
      }

      if (!item.endQtr) {
      } else if (
        item.endQtr !== '' &&
        item.endQtr !== null &&
        !convertQuatreManufacturer(item.endQtr)
      ) {
        showQtrErr = true;
        errorMessagesArray.push(QUARTER_FORMAT_ERROR);
      } else if (
        !showQtrErr &&
        !showStrtDtErr &&
        item.startQtr &&
        item.endQtr
      ) {
        startQtrDate = convertQuatreManufacturer(item.startQtr);
        endQtrDate = convertQuatreManufacturer(item.endQtr);
        if (endQtrDate && startQtrDate) {
          if (
            compareTwoDatesGreaterThanOrEqual(
              new Date(endQtrDate),
              new Date(startQtrDate)
            )
          ) {
            errorMessagesArray.push(FUTURE_QUARTER_ERROR);
          }
        }
      }
    });

    dispatch(setValidateTrigger(true));
    if (errorMessagesArray.length > 0) {
      setErrorMessages([...new Set(errorMessagesArray)]);
      return false;
    }
    setErrorMessages([]);
    return true;
  };
  const validateSingleRowOnBlur = useCallback(
    (rowData, rowIndex, fieldChanged) => {
      const errorMessagesArray = [];
      let showStrtDtErr = false;
      let showQtrErr = false;

      if (!rowData.newOrUpdateRecord) {
        return;
      }

      const allTableData = [...detailTableData, ...tableBottomData];

      const allActiveRows = allTableData.filter((row) => !row.deleteRecord); // 1. Grouping Column Value Required

      if (
        !rowData.groupingColumnValue ||
        !String(rowData.groupingColumnValue).trim()
      ) {
        if (showAllHistory) {
          errorMessagesArray.push(`Grouping Column Value${ID_REQUIRED_ERR}`);
        } else {
          errorMessagesArray.push(
            rowData.rpcClaimGroupingParamPK.groupingColumn + ID_REQUIRED_ERR
          );
        }
      } // 2. Group Number Required & Range

      if (!rowData.groupNum) {
        errorMessagesArray.push(GROUP_NUM_REQUIRED_ERR);
      } else if (
        rowData.groupingColumnValue !== ALL_REMAINING_VALUE &&
        Number(rowData.groupNum) !== 99 &&
        (isNaN(Number(rowData.groupNum)) ||
          Number(rowData.groupNum) < 1 ||
          Number(rowData.groupNum) > 10)
      ) {
        errorMessagesArray.push(GROUP_NUM_RANGE_ERR);
      } // 3. Start Quarter Required & Format

      if (!rowData.startQtr || rowData.startQtr === '') {
        showStrtDtErr = true;
        errorMessagesArray.push(START_QTR_REQUIRED_ERR);
      } else if (
        rowData.startQtr !== '' &&
        rowData.startQtr !== null &&
        !convertQuatreManufacturer(rowData.startQtr)
      ) {
        showQtrErr = true;
        errorMessagesArray.push(QUARTER_FORMAT_ERROR);
      } // 4. End Quarter Format & Date Range

      if (rowData.endQtr) {
        if (
          rowData.endQtr !== '' &&
          rowData.endQtr !== null &&
          !convertQuatreManufacturer(rowData.endQtr)
        ) {
          showQtrErr = true;
          errorMessagesArray.push(QUARTER_FORMAT_ERROR);
        } else if (
          !showQtrErr &&
          !showStrtDtErr &&
          rowData.startQtr &&
          rowData.endQtr
        ) {
          const startQtrDate = convertQuatreManufacturer(rowData.startQtr);
          const endQtrDate = convertQuatreManufacturer(rowData.endQtr);
          if (endQtrDate && startQtrDate) {
            if (
              compareTwoDatesGreaterThanOrEqual(
                new Date(endQtrDate),
                new Date(startQtrDate)
              )
            ) {
              errorMessagesArray.push(FUTURE_QUARTER_ERROR);
            }
          }
        }
      } // 5. Compare against ALL active rows (including existing DB records)

      allActiveRows.forEach((compareRow) => {
        // Skip comparing with itself
        if (
          compareRow === rowData ||
          (compareRow.rpcClaimGroupingParamPK?.groupingColumnValue ===
            rowData.groupingColumnValue &&
            compareRow.rpcClaimGroupingParamPK?.startQtr === rowData.startQtr &&
            compareRow.groupNum === rowData.groupNum &&
            !rowData.newOrUpdateRecord)
        ) {
          // Skip if it's the same existing record
          return;
        }

        const rowA = rowData;
        const rowB = compareRow; // DUPLICATE_ALL check: Same grouping value, group num, and start qtr

        if (
          rowA.groupingColumnValue &&
          rowB.groupingColumnValue &&
          String(rowA.groupingColumnValue).trim() ===
            String(rowB.groupingColumnValue).trim() &&
          rowA.groupNum &&
          rowB.groupNum &&
          String(rowA.groupNum) === String(rowB.groupNum) &&
          rowA.startQtr &&
          rowB.startQtr &&
          String(rowA.startQtr)?.toLowerCase() ===
            String(rowB.startQtr)?.toLowerCase()
        ) {
          // If both have endQtr, they must be different
          if (rowA.endQtr && rowB.endQtr) {
            if (
              String(rowA.endQtr)?.toLowerCase() ===
              String(rowB.endQtr)?.toLowerCase()
            ) {
              errorMessagesArray.push(DUPLICATE_ALL);
            }
          } // If only one has endQtr or both don't have it, it's still a duplicate on start quarter
          else {
            errorMessagesArray.push(DUPLICATE_ALL);
          }
        } // SINGLE_GROUP_HEADER check: Different grouping values, same group, different headers, overlapping dates
        else if (
          rowA.groupingColumnValue &&
          rowB.groupingColumnValue &&
          String(rowA.groupingColumnValue).trim() !==
            String(rowB.groupingColumnValue).trim() &&
          rowA.groupNum &&
          rowB.groupNum &&
          String(rowA.groupNum) === String(rowB.groupNum) &&
          rowA.groupHeader &&
          rowB.groupHeader &&
          String(rowA.groupHeader).trim() !== String(rowB.groupHeader).trim()
        ) {
          // Check for overlapping date ranges
          if (rowA.startQtr && rowB.startQtr) {
            const aStartDate = new Date(convertQuaterToDate(rowA.startQtr));
            const aEndDate = rowA.endQtr
              ? new Date(convertQuaterToDate(rowA.endQtr))
              : new Date('9999-12-31');
            const bStartDate = new Date(convertQuaterToDate(rowB.startQtr));
            const bEndDate = rowB.endQtr
              ? new Date(convertQuaterToDate(rowB.endQtr))
              : new Date('9999-12-31');

            const hasOverlap = aStartDate <= bEndDate && aEndDate >= bStartDate;

            if (hasOverlap) {
              errorMessagesArray.push(SINGLE_GROUP_HEADER);
            }
          }
        } // OVERLAP_DATE check: Same grouping value, same group, overlapping dates
        else if (
          rowA.groupingColumnValue &&
          rowB.groupingColumnValue &&
          String(rowA.groupingColumnValue).trim() ===
            String(rowB.groupingColumnValue).trim() &&
          rowA.groupNum &&
          rowB.groupNum &&
          String(rowA.groupNum) === String(rowB.groupNum) &&
          rowA.startQtr &&
          rowB.startQtr
        ) {
          // Check overlap even if one doesn't have endQtr
          const aStartDate = new Date(convertQuaterToDate(rowA.startQtr));
          const aEndDate = rowA.endQtr
            ? new Date(convertQuaterToDate(rowA.endQtr))
            : new Date('9999-12-31');
          const bStartDate = new Date(convertQuaterToDate(rowB.startQtr));
          const bEndDate = rowB.endQtr
            ? new Date(convertQuaterToDate(rowB.endQtr))
            : new Date('9999-12-31'); // Only check overlap if they're not exact duplicates (handled above)

          const hasOverlap = aStartDate <= bEndDate && aEndDate >= bStartDate;
          const isExactMatch =
            String(rowA.startQtr)?.toLowerCase() ===
              String(rowB.startQtr)?.toLowerCase() &&
            ((rowA.endQtr &&
              rowB.endQtr &&
              String(rowA.endQtr)?.toLowerCase() ===
                String(rowB.endQtr)?.toLowerCase()) ||
              (!rowA.endQtr && !rowB.endQtr));

          if (hasOverlap && !isExactMatch) {
            errorMessagesArray.push(OVERAP_DATE);
          }
        }
      }); // Immediately show errors on blur

      if (errorMessagesArray.length > 0) {
        setErrorMessages([...new Set(errorMessagesArray)]);
        dispatch(setValidateTrigger(true));
      } else {
        setErrorMessages([]);
        dispatch(setValidateTrigger(false));
      }
    },
    [detailTableData, tableBottomData, showAllHistory, dispatch]
  );
  return (
    <div className="tBillPanel custom-check">
      <Spinner load={spinnerLoader} />
      <div className="panel tBillPanel-space devider-line pb-0">
        <SaveCancelPopup
          open={open}
          title="Save"
          onConfim={() => {
            masterDataSave();
          }}
          onCancel={() => {
            setOpen(false);
          }}
        />
        <SaveCancelPopup
          open={openDelete}
          title="Delete"
          moduleName="the selected record"
          onConfim={() => {
            setErrorMessages([]);
            setSuccessMessages([]);
            let dataList = detailTableDataFullData.filter(item => item.deleteRecord !== true);
            dataList[deleteRowIndex].deleteRecord = true;
            const deletedData = dataList[deleteRowIndex]
           
            const newData = detailTableDataFullData.map((dt) => {
              if ((deletedData?.groupNum === dt?.groupNum) && (deletedData?.startQtr === dt?.startQtr)) {
                return { ...dt, deleteRecord: true };
              }
              return dt;
            })
            dispatch(setNewCGPDetailRowData(newData));
            setEdit(true);
            dispatch(setDeleteRowIndex(-1));
            setOpenDelete(false);
          }}
          onCancel={() => {
            setOpenDelete(false);
          }}
        />
        <SaveCancelPopup
          open={openCancel}
          title="Cancel"
          onConfim={() => {
            cancel();
          }}
          onCancel={() => {
            setOpenCancel(false);
          }}
        />
        <SaveCancelPopup
          open={openIgnore}
          title="Ignore"
          onConfim={() => {
            setShoWAllHistory(!showAllHistory);
            dispatchClaimGrouping(!showAllHistory);
            setOpenIgnore(false);
            setEdit(false);
            setEditedData([]);
            setErrorMessages([]);
            setSuccessMessages([]);
          }}
          onCancel={() => {
            setOpenIgnore(false);
          }}
        />
        <CustomSeparator
          parent1="System"
          parent2="Maintain RPC Claim Grouping Parameters"
        />
        <div>
          <DisplayErrorMessages errorMessages={errorMessages || []} />
          <DisplaySuccessMessages successMessages={successMessages} />
          {!fullScreenView && (
            <>
              <div className="flex-block justify-end pb-1">
                <div className="btn-wrapper float-right">
                  <Button
                    className="btn btn-success btn-save"
                    onClick={openSave}
                    data-testid="openSave"
                    disabled={!edit || isReadOnly}
                  >
                    <SVGComponent iconName="Icon-awesome-save" />
                    Save
                  </Button>
                  <Button
                    className="btn btn-cancel"
                    data-testid="open_Cancel"
                    onClick={() => setOpenCancel(true)}
                    disabled={!edit || isReadOnly}
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    Cancel
                  </Button>
                </div>
              </div>
              <div className="mui-custom-form input-md field-xl">
                <div className="sub-radio no-margin">
                  <div className="row">
                    <div className="col-sm-3">
                      <TextField
                        className="mandate-fields mr-2"
                        label="Rebate Program"
                        id="rebateProgram"
                        name="rebateProgram"
                        disabled
                        value={CGPSearchValues?.rebateProgramCd || '-1'}
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ id: 'rebateProgram' }}
                        helperText=""
                      />
                    </div>
                    <div className="col-sm-3">
                      <TextField
                        className="mandate-fields mr-2"
                        id="Quarter"
                        name="Quarter"
                        label="Quarter"
                        disabled
                        value={CGPSearchValues.quarter}
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ id: 'Quarter' }}
                        helperText=""
                      />
                    </div>
                    <div className="col-sm-6">
                      <div className="mui-custom-form with-select input-md mui-custom-form-with-margin2 m-0 mt-4">
                        <div className="sub-radio text-black sub-label">
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                name="showAllHistory"
                                checked={showAllHistory}
                                disabled={isReadOnly}
                                onChange={() => {
                                  handleChangeShowAllHistory();
                                }}
                              />
                            }
                            label="Show All History"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="panel tBillPanel-space pb-0">
          <div className="clearfix" />
          <Grid
            gridHeight={fullScreenView ? '100vh' : 350}
            pinnedBottomRowData={tableBottomData ?? []}
            rowData={
              (detailTableData &&
                detailTableData.filter((item) => !item.deleteRecord)) ||
              []
            }
            onGridReady={onGridReady}
            onCellValueChanged={onEditingStopped}
            columnDefs={cgpDetailTableHead}
            data-testid="onEditingStopped"
            enterMovesDown
            exportFile
            fileName="Maintain Rpc CGP"
            suppressCellFocus
            onCellFocused={onCellFocused}
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            fullScreenView={fullScreenView}
            frameworkComponents={frameworkComponents}
            addTxt="Add row"
            addAction={addCGPRow}
            handleViewHistory={handleViewHistory}
            disableAddAction={isReadOnly}
          />
        </div>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="RPC_CLAIM_GROUPING_PARAM"
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

export default ClaimGroupingParameterDetail;
